export default __webpack_public_path__ + "assets/senhor-dos-passos-component.80ab5a74.svg";